var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _g, _path193, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 226,
    viewBox: "0 0 185 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10512_2732)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 226,
    rx: 24,
    fill: "#0E907A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.2227 199.982C19.3922 202.408 19.7315 233.806 16 251.625V268.542L231.746 277L235.477 154.861C242.601 117.644 174.982 97.4061 149.315 121.365C122.855 146.064 127.265 196.937 67.2227 199.982Z",
    fill: "#628EB3"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3645 205.641C74.7899 202.254 77.3533 196.68 78.3514 189.574C79.4695 181.624 77.3287 172.188 77.3287 172.188C77.3287 172.188 73.3282 181.904 72.0901 189.574C70.9802 196.455 72.0492 202.966 71.6538 205.737L74.3645 205.641Z",
    fill: "url(#paint0_linear_10512_2732)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6832 205.974C67.3069 202.929 65.1062 197.95 64.2526 191.669C63.309 184.725 65.1116 176.596 65.1116 176.596C65.1116 176.596 68.4959 184.967 69.5731 191.669C70.5521 197.751 69.6658 203.567 70.0176 206.062L67.6832 205.974Z",
    fill: "url(#paint1_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3645 205.641C74.7899 202.254 77.3533 196.68 78.3514 189.574C79.4695 181.624 77.3287 172.188 77.3287 172.188C77.3287 172.188 73.3282 181.904 72.0901 189.574C70.9802 196.455 72.0492 202.966 71.6538 205.737L74.3645 205.641Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6832 205.974C67.3069 202.929 65.1062 197.95 64.2526 191.669C63.309 184.725 65.1116 176.596 65.1116 176.596C65.1116 176.596 68.4959 184.967 69.5731 191.669C70.5521 197.751 69.6658 203.567 70.0176 206.062L67.6832 205.974Z",
    fill: "#246266"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2181 205.735C72.2181 201.903 74.0916 195.529 74.2116 187.289C74.3479 177.914 70.9119 166.568 70.9119 166.568C70.9119 166.568 68.0812 178.247 67.8412 187.289C67.6285 195.27 69.5592 202.709 69.5211 205.843L72.2181 205.733V205.735Z",
    fill: "url(#paint2_linear_10512_2732)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4043 205.743C77.1488 202.158 80.2222 196.232 81.913 188.631C83.8192 180.061 82.6329 169.803 82.6329 169.803C82.6329 169.803 77.6779 180.364 75.7008 188.631C73.9418 195.993 74.3781 202.915 73.7264 205.845L76.4043 205.743Z",
    fill: "url(#paint3_linear_10512_2732)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2835 205.755C64.5881 202.608 61.7465 197.455 60.2194 190.935C58.5259 183.7 59.6712 175.199 59.6712 175.199C59.6712 175.199 64.1327 183.953 65.938 190.935C67.5715 197.249 67.176 203.271 67.7896 205.846L65.2835 205.755Z",
    fill: "url(#paint4_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6712 175.199C59.6712 175.199 60.2848 184.682 62.1556 191.29C63.5545 196.234 66.5106 202.914 67.3342 205.799L65.2835 205.755C64.5881 202.608 61.7465 197.455 60.2194 190.935C58.5259 183.7 59.6712 175.199 59.6712 175.199Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6536 205.735C71.4654 203.121 69.8047 194.992 69.9274 186.788C70.0828 176.449 70.9119 166.57 70.9119 166.57C70.9119 166.57 68.0812 178.249 67.8412 187.291C67.6285 195.272 69.5592 202.711 69.5211 205.845L71.6536 205.735Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6735 205.744C76.3962 202.159 76.118 196.137 77.5633 188.522C79.1941 179.938 82.6329 169.801 82.6329 169.801C82.6329 169.801 77.6779 180.362 75.7008 188.629C73.9418 195.991 74.3781 202.913 73.7264 205.843L75.6708 205.741L75.6735 205.744Z",
    fill: "#246266"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7245 181.745C61.0728 181.877 61.7027 185.863 62.7117 189.574C63.6253 192.928 64.847 196.056 65.7197 195.902C67.555 195.574 62.8044 181.527 61.7245 181.745Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9103 176.951C81.2749 176.758 79.8895 181.801 79.0496 185.553C78.2915 188.945 77.8688 193.633 78.7114 193.908C79.5186 194.175 80.9394 190.329 81.6403 186.478C82.4748 181.889 82.4829 177.124 81.9103 176.951Z",
    fill: "#47B3AA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5285 173.629C70.5768 173.648 70.3914 191.921 72.4094 191.979C74.4274 192.036 72.7202 173.607 71.5285 173.629Z",
    fill: "#47B3AA"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5843 223.434H74.9127C77.168 219.005 79.0033 213.153 80.3995 205.117H61.0948C62.5947 213.69 64.4163 219.426 66.5816 223.434H66.5843Z",
    fill: "url(#paint5_linear_10512_2732)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3348 206.443C61.253 206.009 61.1739 205.568 61.0948 205.117H80.3995C80.3204 205.566 80.2414 206.009 80.1623 206.443H61.3348Z",
    fill: "#D8CCFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2206 205.117C68.2206 205.117 68.8778 216.254 70.8031 223.434H66.5816C64.4163 219.426 62.5947 213.692 61.0948 205.117H68.2206Z",
    fill: "#60578F"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M174.246 147.62L128.563 193.705L130.021 195.176L175.704 149.091L174.246 147.62Z",
    fill: "url(#paint6_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M128.963 193.3L172.126 149.757L174.247 147.617L174.801 148.176L175.706 149.089L173.448 151.367C173.185 151.023 172.916 150.689 172.641 150.355L129.563 193.813C129.894 194.091 130.225 194.362 130.566 194.626L130.025 195.172L128.57 193.7L128.97 193.297L128.963 193.3Z",
    fill: "#9E4435"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.144 217.016H151.867V201.41H148.144V217.016Z",
    fill: "url(#paint7_linear_10512_2732)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M150.006 197.504C165.472 197.504 178.011 184.855 178.011 169.252C178.011 153.649 165.472 141 150.006 141C134.539 141 122.001 153.649 122.001 169.252C122.001 184.855 134.539 197.504 150.006 197.504Z",
    fill: "url(#paint8_linear_10512_2732)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M152.94 177.671C154.625 176.586 156.982 176.666 158.745 175.538C159.65 174.959 160.502 174.166 161.325 173.511C161.915 173.041 162.512 172.125 163.203 171.646C164.144 170.994 164.659 171.546 165.692 171.345C166.665 171.156 167.114 170.515 168.271 170.624C168.016 170.882 168.229 170.534 168.153 171.034C169.038 171.259 170.199 172.727 170.287 173.507C170.363 174.175 169.756 174.89 169.848 175.65C169.94 176.398 170.402 176.871 170.425 177.664C170.471 179.308 169.583 180.237 168.589 181.315C167.803 182.172 167.35 183.342 166.403 184.077C165.803 184.543 165.036 184.695 164.403 185.112C162.05 186.663 162.004 190.39 160.361 192.414C159.876 193.012 155.742 196.67 154.693 195.595C154.153 195.039 155.208 194.818 155.352 194.328C155.539 193.693 155.31 193.445 155.267 192.88C155.162 191.554 154.369 190.519 154.228 189.269C154.146 188.518 154.841 187.794 154.271 187.122C153.943 186.739 153.363 187.017 152.946 186.821C151.389 186.091 151.635 184.993 151.904 183.481C152.277 181.381 150.75 179.083 152.943 177.671H152.94Z",
    fill: "url(#paint9_radial_10512_2732)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M176.837 169.871C176.145 170.152 175.519 169.725 174.857 170.059C174.362 170.307 174.041 170.939 173.608 170.949C173.375 171.117 173.077 171.177 172.769 171.15C172.215 169.96 173.634 169.328 174.428 168.74C174.995 168.316 175.336 168.502 175.677 167.698C175.965 167.013 175.896 166.114 175.867 165.37C175.791 163.564 174.139 162.718 172.428 163.032C171.713 163.164 171.402 163.67 170.753 162.992C170.163 162.374 170.192 161.362 169.524 160.674C168.173 159.288 167.439 157.717 165.678 156.825C164.816 156.388 163.915 155.928 163.19 155.353C162 154.41 162.908 154.159 162.44 153.064C162.092 152.248 161.259 152.463 160.532 152.281C159.84 152.109 158.637 151.725 158.244 151.08C157.706 150.194 158.224 149.714 158.548 148.954C158.706 148.583 158.427 148.233 158.83 147.968C159.502 147.529 159.588 148.385 160.073 148.388C160.538 148.392 160.709 147.962 161.092 147.965C161.827 147.972 161.879 148.474 162.325 148.937C163.269 149.916 164.613 150.402 165.99 150.247C167.203 150.111 167.967 149.731 166.737 148.802C166.141 148.352 165.898 148.593 165.76 147.747C165.728 147.552 166.029 147.171 165.891 146.794C166.16 146.665 166.465 146.616 166.793 146.629C173.49 151.695 177.863 159.715 178.011 168.776C177.676 169.285 177.286 169.689 176.84 169.871H176.837Z",
    fill: "url(#paint10_radial_10512_2732)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.882 156.144C128.347 156.392 128.603 157.176 129.013 157.302C129.308 157.391 131.045 156.769 131.497 156.643C131.953 156.518 132.769 156.359 132.989 155.942C133.425 155.116 132.497 154.474 133.959 154.471C134.484 154.471 135.31 154.729 135.92 154.801C136.605 154.884 137.182 155.089 137.788 155.344C138.309 155.562 138.709 155.843 139.23 155.81C139.253 155.913 139.289 156.008 139.447 155.995C140.302 156.071 141.299 157.146 141.653 157.834C141.951 158.409 141.922 158.899 142.325 159.471C142.64 159.917 143.056 160.248 143.397 160.658C144.387 161.852 144.646 162.89 144.495 164.425C144.384 165.562 145.023 166.882 144.659 167.867C144.387 168.605 143.653 168.856 143.223 169.445C142.856 169.951 142.82 170.639 142.391 171.115C141.437 172.176 140.099 171.809 138.903 171.928C138.454 171.975 137.978 172.319 137.457 172.14C136.9 171.948 136.674 171.204 135.962 171.072C135.336 170.956 135.116 171.356 134.638 171.416C134.133 171.475 133.667 171.217 133.176 171.28C131.773 171.455 132.471 173.38 131.74 174.425C131.406 174.905 130.878 175.202 130.586 175.788C130.18 176.605 130.265 177.269 130.078 178.116C129.963 178.645 129.232 179.22 129.239 179.627C129.249 180.196 129.862 180.203 130.052 180.656C130.34 181.337 130.065 182.382 129.78 183.013C129.383 183.887 129.239 184.369 129.032 185.312C128.944 185.719 128.698 186.717 128.272 187.068C124.354 182.207 122.007 176.009 122.007 169.256C122.007 165.202 122.856 161.343 124.381 157.857C125.302 156.541 126.488 155.4 127.888 156.147L127.882 156.144Z",
    fill: "url(#paint11_radial_10512_2732)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M146.711 141.771C148.219 141.298 149.462 141.761 150.97 142.072C151.655 142.214 154.284 142.055 154.375 143.041C154.779 143.484 153.818 143.375 153.569 143.309C153.169 143.203 152.858 143.077 152.451 143.266C152.425 143.778 152.638 144.363 152.868 144.777C153.199 145.372 153.733 145.587 153.556 146.43C153.428 147.029 152.605 147.254 151.999 147.055C151.51 146.897 151.114 146.262 150.72 145.924C150.265 145.534 149.786 145.319 149.206 145.207C148.445 145.058 147.668 144.949 146.918 144.734C145.987 144.469 145.075 143.854 144.108 143.795C143.672 142.912 146.19 141.933 146.711 141.767V141.771Z",
    fill: "url(#paint12_radial_10512_2732)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M141.456 153.908C141.568 154.692 141.335 155.135 140.463 155.247C139.791 155.333 139.053 154.937 138.476 154.573C138.004 154.275 137.916 154.077 137.726 153.62C137.493 153.058 137.07 153.111 136.713 152.714C136.352 152.311 136.474 151.944 135.788 151.686C135.228 151.474 134.71 151.53 134.176 151.768C133.205 152.205 131.406 153.2 130.389 152.337C129.842 151.874 130.062 151.206 130.422 150.657C131.189 149.49 132.396 148.117 133.785 147.75C134.572 147.542 135.529 147.598 136.264 147.946C136.87 148.233 137.067 148.921 137.667 149.239C138.349 149.599 139.037 149.374 138.572 150.36C138.44 150.637 138.237 150.766 138.257 151.16C138.27 151.461 138.286 151.712 138.578 151.864C139.371 152.274 140.46 151.577 141.26 152.106V152.112C141.591 152.281 141.558 152.602 141.525 152.916C141.483 153.309 141.397 153.485 141.456 153.908Z",
    fill: "url(#paint13_radial_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.006 141C156.008 141 161.568 142.905 166.124 146.146C162.708 144.337 158.821 143.312 154.697 143.312C141.109 143.312 130.094 154.423 130.094 168.131C130.094 181.838 141.109 192.95 154.697 192.95C162.944 192.95 170.242 188.856 174.706 182.576C169.986 191.458 160.696 197.504 150.006 197.504C134.54 197.504 122.001 184.854 122.001 169.252C122.001 153.649 134.54 141 150.006 141Z",
    fill: "#26426A"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M149.576 201.406V201.476C149.721 201.476 149.861 201.476 150.006 201.476C150.632 201.476 151.251 201.456 151.868 201.419V204.892C151.251 204.925 150.629 204.945 150.006 204.945C149.861 204.945 149.721 204.945 149.576 204.945V217.015H148.144V204.898V201.426V201.41H149.576V201.406Z",
    fill: "#9E4435"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M126.656 222.358H173.356V219.467C157.598 214.844 142.033 214.844 126.656 219.467V222.358Z",
    fill: "url(#paint14_linear_10512_2732)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M150.006 203.574C168.766 203.574 184.029 188.177 184.029 169.254C184.029 160.074 180.483 151.446 174.041 144.961L171.615 147.418C177.404 153.248 180.594 161.003 180.594 169.254C180.594 186.265 166.875 200.109 150.009 200.109C141.83 200.109 134.143 196.891 128.364 191.051L125.928 193.501C132.356 199.999 140.909 203.578 150.006 203.578V203.574Z",
    fill: "url(#paint15_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M149.825 216.004C146.76 216.936 145.062 219.473 145.062 219.473H173.356V222.363H126.656V219.473C134.33 217.165 142.056 216.007 149.825 216.004Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M180.735 168.098C180.735 169.6 180.627 171.078 180.42 172.523C180.532 171.448 180.591 170.357 180.591 169.253C180.591 160.998 177.404 153.243 171.612 147.416L172.251 146.771C177.725 152.539 180.735 160.082 180.735 168.098Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M126.577 192.845C132.946 199.025 141.289 202.418 150.15 202.418C167.272 202.418 181.482 189.591 183.833 172.963C181.994 190.149 167.524 203.573 150.009 203.573C140.909 203.573 132.36 199.994 125.931 193.496L126.58 192.841L126.577 192.845Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M153.939 148.024C144.203 156.199 165.672 167.43 170.94 163.23C179.112 156.718 162.433 140.894 153.939 148.024Z",
    fill: "#FFF7E6"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M170.95 167.55C163.312 167.024 166.003 177.637 169.668 177.782C175.355 178.007 176.935 167.964 170.95 167.55Z",
    fill: "#FFF7E6"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9999 225.967L113.976 225.782L82.3977 194.107L50.9999 225.964V225.967ZM99.3653 219.915L65.5744 220.015L82.4207 202.921L99.3653 219.915Z",
    fill: "url(#paint16_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5983 199.058L79.736 198.919L78.6902 197.871L78.5526 198.007L79.5983 199.058Z",
    fill: "#463332"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7492 199.922L78.8836 199.783L77.8379 198.734L77.7035 198.87L78.7492 199.922Z",
    fill: "#463332"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8088 201.886L76.9432 201.751L75.8975 200.699L75.7631 200.838L76.8088 201.886Z",
    fill: "#463332"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9561 202.75L76.0937 202.614L75.048 201.562L74.9103 201.701L75.9561 202.75Z",
    fill: "#463332"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0155 204.713L74.1531 204.578L73.1074 203.529L72.973 203.665L74.0155 204.713Z",
    fill: "#463332"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1665 205.576L73.3009 205.441L72.2552 204.393L72.1208 204.528L73.1665 205.576Z",
    fill: "#463332"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M71.226 207.543L71.3604 207.404L70.3179 206.355L70.1802 206.491L71.226 207.543Z",
    fill: "#463332"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3735 208.406L70.5112 208.267L69.4654 207.219L69.3278 207.354L70.3735 208.406Z",
    fill: "#463332"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M68.436 210.371L68.5704 210.235L67.5247 209.184L67.3903 209.322L68.436 210.371Z",
    fill: "#463332"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5838 211.234L67.7182 211.095L66.6725 210.047L66.5381 210.182L67.5838 211.234Z",
    fill: "#463332"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6433 213.199L65.7809 213.063L64.7352 212.012L64.5975 212.151L65.6433 213.199Z",
    fill: "#463332"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7909 214.062L64.9286 213.927L63.8829 212.875L63.7452 213.014L64.7909 214.062Z",
    fill: "#463332"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8305 216.052L62.9649 215.914L61.9191 214.865L61.7847 215.001L62.8305 216.052Z",
    fill: "#463332"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9783 216.916L62.1127 216.777L61.067 215.729L60.9326 215.864L61.9783 216.916Z",
    fill: "#463332"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0275 218.891L60.1619 218.755L59.1162 217.707L58.9818 217.843L60.0275 218.891Z",
    fill: "#463332"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1758 219.754L59.3102 219.618L58.2645 218.566L58.1301 218.705L59.1758 219.754Z",
    fill: "#463332"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1794 221.777L57.3138 221.641L56.2681 220.59L56.1337 220.729L57.1794 221.777Z",
    fill: "#463332"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M56.327 222.64L56.4614 222.505L55.4189 221.453L55.2812 221.592L56.327 222.64Z",
    fill: "#463332"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4305 198.976L81.6141 198.791L79.6898 196.859L79.5062 197.045L81.4305 198.976Z",
    fill: "#463332"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6278 201.817L78.8113 201.632L76.8871 199.697L76.7035 199.886L78.6278 201.817Z",
    fill: "#463332"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8251 204.657L76.0087 204.472L74.0844 202.537L73.9008 202.726L75.8251 204.657Z",
    fill: "#463332"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0224 207.499L73.206 207.314L71.2817 205.379L71.0981 205.567L73.0224 207.499Z",
    fill: "#463332"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2194 210.339L70.403 210.153L68.4787 208.219L68.2952 208.404L70.2194 210.339Z",
    fill: "#463332"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4166 213.178L67.6001 212.993L65.6759 211.059L65.4923 211.244L67.4166 213.178Z",
    fill: "#463332"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6138 216.02L64.7973 215.832L62.8698 213.9L62.6862 214.086L64.6138 216.02Z",
    fill: "#463332"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8111 218.86L61.9947 218.672L60.0671 216.74L59.8835 216.925L61.8111 218.86Z",
    fill: "#463332"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0083 221.699L59.1919 221.513L57.2643 219.582L57.0807 219.767L59.0083 221.699Z",
    fill: "#463332"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2022 224.538L56.3858 224.353L54.4615 222.422L54.2812 222.607L56.2022 224.538Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8473 225.888C78.8473 225.626 78.8473 224.803 78.8408 223.381H80.4372L80.4274 219.971L99.3651 219.915L84.9676 205.473C84.925 205.311 84.8692 205.156 84.8659 204.981L84.843 196.865C84.843 196.776 84.8823 196.703 84.8922 196.617L113.972 225.785L78.844 225.888H78.8473Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7194 219.573L99.0244 219.576L82.4273 202.929L82.7748 202.578L99.7194 219.573Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3945 194.111L82.6437 194.359L51.8293 225.624L113.632 225.442L113.973 225.786L50.9999 225.968L82.3945 194.111Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5421 220.499L84.2928 220.443L84.2915 219.99L65.5407 220.046L65.5421 220.499Z",
    fill: "#FFF7E6"
  }))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M180.151 224.364L180.966 224.15L180.4 221.955L179.585 222.169L180.151 224.364Z",
    fill: "url(#paint17_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M180.148 224.369L180.563 224.26L179.997 222.064L179.582 222.173L180.148 224.369Z",
    fill: "#463332"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M177.86 225.709L183.531 225.692C183.983 225.692 184.35 225.318 184.35 224.862C184.35 224.406 183.98 224.035 183.528 224.035L177.856 224.052C177.404 224.052 177.037 224.425 177.037 224.882C177.037 225.338 177.407 225.709 177.86 225.709Z",
    fill: "url(#paint18_linear_10512_2732)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M180.04 222.244C180.817 222.039 181.282 221.239 181.079 220.455L180.768 219.245C180.564 218.461 179.771 217.991 178.994 218.197C178.217 218.402 177.752 219.202 177.955 219.986L178.266 221.196C178.47 221.98 179.263 222.449 180.04 222.244Z",
    fill: "url(#paint19_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M178.998 218.196C179.181 218.146 179.365 218.143 179.545 218.166C179.748 218.289 179.971 218.378 180.204 218.444C180.469 218.636 180.682 218.904 180.771 219.248L181.056 220.349C180.719 220.716 180.302 221.017 179.788 221.152C179.548 221.215 179.309 221.232 179.07 221.228C179.394 221.761 180.014 222.055 180.643 221.896C180.473 222.052 180.279 222.184 180.04 222.247C179.263 222.452 178.47 221.979 178.266 221.199L177.955 219.988C177.752 219.205 178.217 218.404 178.994 218.199L178.998 218.196Z",
    fill: "#463332"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M179.627 220.646C181.073 220.265 181.938 218.777 181.561 217.322L166.855 160.27L161.623 161.642L176.329 218.694C176.706 220.153 178.181 221.026 179.624 220.646H179.627Z",
    fill: "url(#paint20_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M161.627 161.642L166.859 160.27L167.416 162.432C166.836 163.438 165.98 164.248 164.957 164.777L178.165 216.012C178.542 217.471 180.017 218.344 181.459 217.964C181.525 217.947 181.584 217.914 181.649 217.894C181.702 219.151 180.886 220.318 179.63 220.646C178.184 221.026 176.709 220.15 176.336 218.694L162.607 165.438L161.63 161.642H161.627Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M177.853 224.055L180.118 224.049C179.666 224.049 179.299 224.423 179.299 224.879C179.299 225.335 179.669 225.706 180.122 225.702L177.857 225.709C177.404 225.709 177.034 225.342 177.034 224.886C177.034 224.429 177.398 224.055 177.85 224.055H177.853Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M177.857 225.146L183.528 225.129C183.882 225.129 184.177 224.898 184.291 224.58C184.324 224.669 184.347 224.762 184.347 224.861C184.347 225.318 183.983 225.691 183.528 225.691L177.857 225.708C177.404 225.708 177.034 225.341 177.034 224.884C177.034 224.785 177.057 224.693 177.089 224.603C177.204 224.921 177.499 225.149 177.857 225.149V225.146Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M183.793 224.408C183.895 224.093 181.971 224.169 181.902 224.335C181.797 224.593 183.705 224.682 183.793 224.408Z",
    fill: "#FFF7E6"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M181.659 224.409C181.695 224.18 181.026 224.237 181.003 224.356C180.967 224.541 181.63 224.607 181.659 224.409Z",
    fill: "#FFF7E6"
  }))), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M142.548 223.342C143.981 223.755 145.472 222.916 145.882 221.47L146.515 219.238C146.924 217.793 146.092 216.288 144.659 215.875C143.227 215.462 141.735 216.302 141.325 217.747L140.693 219.979C140.283 221.424 141.116 222.929 142.548 223.342Z",
    fill: "url(#paint21_linear_10512_2732)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M142.001 225.272C143.053 225.576 144.151 224.957 144.453 223.896L144.918 222.252C145.22 221.191 144.607 220.083 143.554 219.779C142.502 219.474 141.404 220.093 141.102 221.154L140.637 222.798C140.335 223.86 140.948 224.967 142.001 225.272Z",
    fill: "url(#paint22_linear_10512_2732)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M143.118 221.32C144.554 221.734 146.049 220.894 146.459 219.445L162.787 161.712L157.591 160.217L141.263 217.951C140.853 219.399 141.686 220.907 143.121 221.32H143.118Z",
    fill: "url(#paint23_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M141.26 217.951L156.988 162.34L157.588 160.217L162.784 161.712L161.735 165.422C160.683 165.336 159.712 164.976 158.886 164.413L144.099 216.704C143.689 218.152 144.521 219.66 145.957 220.074C146.023 220.093 146.092 220.097 146.157 220.11C145.541 221.129 144.312 221.661 143.118 221.317C141.683 220.904 140.853 219.396 141.263 217.947L141.26 217.951Z",
    fill: "#9E4435"
  }))), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M160.44 155.392L163.99 155.382L163.967 147.423C163.967 146.434 163.167 145.633 162.187 145.637C161.207 145.637 160.414 146.444 160.417 147.432L160.44 155.392Z",
    fill: "url(#paint24_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M162.187 145.637C162.292 145.637 162.384 145.68 162.485 145.696C161.928 146 161.538 146.576 161.541 147.257L161.551 150.604C161.767 150.574 161.981 150.544 162.203 150.541C162.826 150.541 163.413 150.66 163.98 150.835L163.993 155.211V155.382L160.443 155.392L160.43 150.845L160.42 147.432C160.42 146.444 161.21 145.64 162.19 145.637H162.187Z",
    fill: "#463332"
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M166.475 162.118C168.826 159.746 168.826 155.902 166.475 153.531C164.125 151.16 160.314 151.16 157.963 153.531C155.613 155.902 155.613 159.746 157.963 162.118C160.314 164.489 164.125 164.489 166.475 162.118Z",
    fill: "url(#paint25_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M158.981 157.654C158.988 159.559 160.535 161.097 162.443 161.094C164.351 161.087 165.891 159.539 165.885 157.635C165.878 155.73 164.331 154.192 162.423 154.195C160.515 154.202 158.975 155.75 158.981 157.654Z",
    fill: "#9E4435"
  }))), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M164.509 160.135C165.774 158.859 165.774 156.79 164.509 155.514C163.245 154.238 161.194 154.238 159.929 155.514C158.664 156.79 158.664 158.859 159.929 160.135C161.194 161.411 163.245 161.411 164.509 160.135Z",
    fill: "url(#paint26_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M161.214 151.855C158.837 152.53 157.086 154.713 157.093 157.325C157.103 160.467 159.633 163.003 162.748 162.997C165.337 162.99 167.491 161.211 168.147 158.81C167.681 161.687 165.226 163.89 162.243 163.9C158.919 163.91 156.214 161.198 156.205 157.844C156.195 154.832 158.368 152.345 161.217 151.859L161.214 151.855Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M162.108 155.532C160.896 156.557 163.58 157.95 164.236 157.424C165.252 156.607 163.167 154.639 162.108 155.532Z",
    fill: "#FFF7E6"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M164.236 157.963C163.282 157.9 163.623 159.223 164.079 159.24C164.79 159.266 164.983 158.013 164.236 157.963Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M162.407 146.074C161.571 146.544 162.977 147.635 163.426 147.397C164.124 147.027 163.138 145.664 162.407 146.074Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M162.21 154.557C162.249 154.557 162.286 154.567 162.325 154.567C160.745 154.633 159.486 155.939 159.489 157.549C159.493 159.2 160.823 160.529 162.456 160.526C164.092 160.522 165.41 159.18 165.406 157.533C165.406 157.368 165.383 157.206 165.357 157.047C165.416 157.295 165.459 157.549 165.459 157.814C165.465 159.62 164.016 161.085 162.23 161.091C160.44 161.098 158.988 159.636 158.981 157.834C158.975 156.032 160.424 154.563 162.21 154.557Z",
    fill: "#463332"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M124.679 196.26L154.434 196.174L167.917 225.748L138.732 225.834L124.751 197.268C124.59 196.944 124.58 196.587 124.676 196.263L124.679 196.26Z",
    fill: "url(#paint27_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M124.679 196.26L154.434 196.174L167.917 225.748L138.732 225.834L124.751 197.268C124.59 196.944 124.58 196.587 124.676 196.263L124.679 196.26Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M125.672 199.14L124.754 197.265C124.594 196.941 124.584 196.584 124.679 196.26L154.435 196.174L155.746 199.051L125.672 199.14Z",
    fill: "#60578F"
  }))), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M154.434 196.173L124.679 196.259C124.784 195.906 125.02 195.595 125.374 195.419L130.462 192.886C130.54 192.847 130.875 192.754 130.957 192.754C130.986 192.754 131.012 192.754 131.042 192.754L160.381 192.668L160.397 198.174L155.356 198.187L154.438 196.173H154.434Z",
    fill: "url(#paint28_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M154.434 196.173L124.679 196.259C124.784 195.906 125.02 195.595 125.374 195.419L130.462 192.886C130.766 192.734 130.953 192.754 131.042 192.754L160.381 192.668L154.434 196.173Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M148.367 195.353L153.454 192.819C153.759 192.667 153.946 192.687 154.034 192.687L156.824 192.681C156.739 192.681 156.549 192.661 156.244 192.813L151.156 195.346C150.802 195.521 150.566 195.835 150.461 196.186L147.672 196.193C147.776 195.839 148.012 195.528 148.367 195.353Z",
    fill: "#60578F"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M127.823 195.413L132.91 192.88C133.215 192.728 133.402 192.748 133.491 192.748L136.28 192.741C136.195 192.741 136.005 192.721 135.7 192.873L130.612 195.407C130.258 195.582 130.022 195.896 129.917 196.247L127.128 196.253C127.233 195.899 127.469 195.588 127.823 195.413Z",
    fill: "#60578F"
  }))), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M168.881 224.204L173.654 221.827L174.074 222.68C174.988 222.223 175.457 221.992 175.457 221.992L161.476 193.426C161.141 192.745 160.322 192.464 159.647 192.801L154.559 195.334C153.884 195.671 153.605 196.498 153.939 197.179L167.921 225.745C167.921 225.745 168.393 225.511 169.301 225.058L168.881 224.204Z",
    fill: "url(#paint29_linear_10512_2732)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M160.913 195.773L173.665 221.825L168.892 224.203L156.14 198.151C155.928 197.718 156.104 197.195 156.533 196.982L159.754 195.377C160.183 195.163 160.701 195.34 160.913 195.773Z",
    fill: "#CEB6AA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M160.89 195.737L156.117 198.115L168.882 224.194L173.655 221.816L160.89 195.737Z",
    fill: "#CEB6AA"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M159.689 195.288L156.49 196.882C156.054 197.097 155.877 197.63 156.093 198.066L168.885 224.202L173.657 221.824L160.866 195.689C160.653 195.249 160.125 195.07 159.693 195.288H159.689Z",
    fill: "#FFE6D6"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M160.24 197.553C160.024 197.113 159.499 196.935 159.063 197.15L156.313 198.519L156.09 198.062C155.877 197.622 156.054 197.093 156.486 196.878L159.686 195.284C160.122 195.069 160.646 195.248 160.859 195.685L173.651 221.82L172.415 222.435L160.237 197.55L160.24 197.553Z",
    fill: "#CEB6AA"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M158.102 197.547C158.102 197.547 158.765 198.972 159.761 201.109C160.781 203.235 162.141 206.066 163.501 208.9C164.905 211.711 166.308 214.525 167.36 216.632C168.438 218.728 169.156 220.124 169.156 220.124C169.156 220.124 168.494 218.698 167.498 216.562C166.478 214.436 165.118 211.605 163.757 208.771C162.354 205.96 160.951 203.149 159.899 201.039C158.82 198.942 158.102 197.547 158.102 197.547Z",
    fill: "#CEB6AA"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M168.176 215.256C168.176 215.256 168.343 215.689 168.612 216.327C168.881 216.966 169.274 217.802 169.671 218.636C170.087 219.462 170.503 220.286 170.844 220.891C171.182 221.496 171.425 221.893 171.425 221.893C171.425 221.893 171.261 221.46 170.989 220.822C170.72 220.183 170.326 219.347 169.927 218.513C169.51 217.687 169.094 216.863 168.753 216.261C168.415 215.656 168.173 215.259 168.173 215.259L168.176 215.256Z",
    fill: "#CEB6AA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M158.345 200.561C158.345 200.561 158.843 201.649 159.588 203.282C160.342 204.913 161.381 207.065 162.423 209.222C163.485 211.368 164.547 213.511 165.37 215.105C166.203 216.695 166.757 217.757 166.757 217.757C166.757 217.757 166.259 216.669 165.514 215.035C164.76 213.405 163.721 211.252 162.679 209.096C161.617 206.95 160.555 204.807 159.729 203.213C158.896 201.622 158.342 200.561 158.342 200.561H158.345Z",
    fill: "#CEB6AA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M150.062 204.54L150.039 196.924H151.379C151.376 195.462 151.373 194.715 151.373 194.715L89.7671 194.893C88.6985 194.893 87.833 195.773 87.8363 196.854L87.8593 204.97C87.8593 206.048 88.7312 206.921 89.8032 206.918L151.409 206.739C151.409 206.739 151.409 205.988 151.402 204.537H150.062V204.54Z",
    fill: "url(#paint30_linear_10512_2732)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M150.061 204.539L92.396 204.707C91.7174 204.707 91.1667 204.158 91.1667 203.474L91.1536 198.335C91.1536 197.65 91.6977 197.094 92.3763 197.094L150.042 196.926L150.065 204.542L150.061 204.539Z",
    fill: "#CEB6AA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M150.045 196.916L119.205 197.008L119.227 204.624L150.068 204.532L150.045 196.916Z",
    fill: "#CEB6AA"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M150.045 196.916L119.205 197.008L119.227 204.624L150.068 204.532L150.045 196.916Z",
    fill: "#FFE6D6"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M120.752 201.721C120.752 201.721 122.273 201.764 124.554 201.823C126.836 201.873 129.878 201.883 132.92 201.889C135.962 201.866 139.004 201.84 141.286 201.777C143.567 201.701 145.088 201.651 145.088 201.651C145.088 201.651 143.567 201.608 141.286 201.549C139.004 201.499 135.962 201.489 132.92 201.482C129.878 201.506 126.836 201.535 124.554 201.595C122.273 201.671 120.752 201.721 120.752 201.721Z",
    fill: "#CEB6AA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M138.329 199.865C138.329 199.865 138.978 199.921 139.955 199.974C140.932 200.027 142.23 200.043 143.531 200.053C144.833 200.037 146.131 200.014 147.108 199.954C148.085 199.901 148.734 199.835 148.734 199.835C148.734 199.835 148.085 199.772 147.108 199.726C146.131 199.673 144.833 199.656 143.531 199.646C142.23 199.663 140.932 199.689 139.955 199.746C138.981 199.805 138.329 199.865 138.329 199.865Z",
    fill: "#CEB6AA"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M124.705 203.286C124.705 203.286 125.698 203.342 127.19 203.392C128.681 203.445 130.668 203.458 132.655 203.465C134.641 203.445 136.628 203.418 138.116 203.359C139.604 203.306 140.597 203.237 140.597 203.237C140.597 203.237 139.604 203.174 138.113 203.127C136.621 203.075 134.635 203.061 132.648 203.055C130.661 203.075 128.675 203.101 127.187 203.161C125.698 203.22 124.705 203.283 124.705 203.283V203.286Z",
    fill: "#CEB6AA"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M150.042 196.919L119.201 197.012L119.207 198.741L150.047 198.649L150.042 196.919Z",
    fill: "#CEB6AA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7671 194.897L117.903 194.814L117.939 206.839L89.8032 206.921C88.7345 206.921 87.8625 206.052 87.8593 204.974L87.8363 196.858C87.8363 195.78 88.6984 194.9 89.7671 194.897Z",
    fill: "url(#paint31_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7671 194.897L117.657 194.814C116.589 194.814 115.723 195.694 115.727 196.776L115.75 204.891C115.75 205.969 116.622 206.842 117.693 206.839L89.8032 206.921C88.7345 206.921 87.8625 206.052 87.8593 204.974L87.8363 196.858C87.8363 195.78 88.6984 194.9 89.7671 194.897Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M109.154 204.911L109.131 196.796C109.131 195.718 109.993 194.838 111.062 194.835L112.966 194.828C111.897 194.828 111.032 195.708 111.035 196.789L111.058 204.905C111.058 205.983 111.93 206.856 113.002 206.852L111.098 206.859C110.029 206.859 109.157 205.989 109.154 204.911Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M90.9897 204.962L90.9668 196.847C90.9668 195.768 91.8289 194.889 92.8976 194.886L94.8022 194.879C93.7335 194.879 92.8681 195.759 92.8714 196.84L92.8943 204.955C92.8943 206.033 93.7663 206.906 94.8383 206.903L92.9337 206.91C91.865 206.91 90.993 206.04 90.9897 204.962Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M115.75 204.625V204.89C115.753 205.968 116.622 206.841 117.694 206.837L89.8032 206.92C88.7346 206.92 87.8626 206.05 87.8593 204.972V204.708L115.75 204.625Z",
    fill: "#398191"
  }))), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M147.554 193.354L147.54 188.685H148.363C148.363 187.788 148.36 187.332 148.36 187.332L91.9927 187.497C91.3371 187.497 90.806 188.036 90.8093 188.698L90.8224 193.675C90.8224 194.336 91.3567 194.872 92.0124 194.869L148.38 194.703C148.38 194.703 148.38 194.244 148.376 193.351H147.554V193.354Z",
    fill: "url(#paint32_linear_10512_2732)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5919 188.836L147.546 188.674L147.56 193.344L93.6056 193.505C93.1893 193.506 92.8539 193.167 92.8527 192.75L92.8434 189.599C92.8422 189.179 93.1788 188.84 93.5919 188.839L93.5919 188.836Z",
    fill: "#CEB6AA"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M147.543 188.677L121.852 188.754L121.866 193.423L147.557 193.346L147.543 188.677Z",
    fill: "#CEB6AA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M147.543 188.677L121.852 188.754L121.866 193.423L147.557 193.346L147.543 188.677Z",
    fill: "#FFE6D6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M122.801 191.644C122.801 191.644 124.158 191.667 126.19 191.7C128.226 191.71 130.937 191.723 133.651 191.736C136.366 191.707 139.077 191.68 141.112 191.657C143.148 191.611 144.502 191.581 144.502 191.581C144.502 191.581 143.145 191.558 141.112 191.525C139.077 191.515 136.366 191.502 133.651 191.488C130.937 191.518 128.226 191.545 126.19 191.568C124.155 191.614 122.801 191.644 122.801 191.644Z",
    fill: "#CEB6AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M140.361 190.487C140.361 190.487 140.761 190.526 141.358 190.549C141.955 190.563 142.754 190.583 143.551 190.602C145.147 190.609 146.741 190.467 146.741 190.467C146.741 190.467 145.144 190.335 143.551 190.351C142.754 190.374 141.958 190.397 141.358 190.414C140.761 190.444 140.361 190.483 140.361 190.483V190.487Z",
    fill: "#CEB6AA"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M125.226 192.607C125.226 192.607 126.259 192.631 127.81 192.667C129.36 192.677 131.425 192.693 133.491 192.707C137.621 192.707 141.755 192.558 141.755 192.558C141.755 192.558 137.624 192.435 133.491 192.455C131.425 192.482 129.36 192.508 127.81 192.528C126.259 192.574 125.226 192.604 125.226 192.604V192.607Z",
    fill: "#CEB6AA"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M147.543 188.677L121.852 188.754L121.855 189.812L147.546 189.735L147.543 188.677Z",
    fill: "#CEB6AA"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9894 187.498L121.053 187.412L121.073 194.783L92.0091 194.869C91.3535 194.869 90.8191 194.337 90.8191 193.676L90.806 188.699C90.806 188.037 91.3338 187.498 91.9894 187.498Z",
    fill: "url(#paint33_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9894 187.497L120.902 187.414C120.247 187.414 119.716 187.953 119.719 188.615L119.732 193.592C119.732 194.253 120.267 194.789 120.922 194.785L92.0091 194.868C91.3535 194.868 90.8191 194.336 90.8191 193.674L90.806 188.697C90.806 188.036 91.3338 187.497 91.9894 187.497Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M115.69 193.603L115.677 188.626C115.677 187.965 116.205 187.426 116.861 187.426H118.028C117.372 187.426 116.841 187.962 116.844 188.623L116.857 193.6C116.857 194.261 117.392 194.797 118.047 194.794H116.88C116.225 194.8 115.69 194.265 115.69 193.603Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M112.527 193.611L112.514 188.634C112.514 187.973 113.042 187.434 113.697 187.434H114.864C114.209 187.434 113.678 187.969 113.681 188.631L113.694 193.608C113.694 194.269 114.228 194.805 114.884 194.802H113.717C113.061 194.808 112.527 194.272 112.527 193.611Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M96.251 193.658L96.2379 188.681C96.2379 188.02 96.7657 187.48 97.4213 187.48H98.5883C97.9327 187.48 97.4016 188.016 97.4049 188.678L97.418 193.655C97.418 194.316 97.9524 194.852 98.608 194.848H97.441C96.7854 194.855 96.251 194.319 96.251 193.658Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0877 193.668L93.0746 188.691C93.0746 188.029 93.6024 187.49 94.258 187.49H95.425C94.7694 187.49 94.2383 188.026 94.2416 188.687L94.2547 193.664C94.2547 194.326 94.789 194.862 95.4447 194.858H94.2777C93.622 194.865 93.0877 194.329 93.0877 193.668Z",
    fill: "#9E4435"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M119.735 193.427V193.589C119.735 194.251 120.27 194.786 120.925 194.783L92.0123 194.866C91.3567 194.866 90.8224 194.333 90.8224 193.672V193.51L119.735 193.424V193.427Z",
    fill: "#9E4435"
  }))), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4302 223.369L83.3908 209.39H81.7944C81.7878 207.657 81.7878 206.768 81.7878 206.768L155.185 206.553C156.46 206.549 157.496 207.588 157.499 208.874L157.542 223.448C157.545 224.735 156.516 225.78 155.241 225.783L81.8436 225.998C81.8436 225.998 81.8436 225.102 81.837 223.372H83.4335L83.4302 223.369Z",
    fill: "url(#paint34_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M154.083 223.163L85.3802 223.368L85.3391 209.39L154.042 209.184C154.848 209.182 155.506 209.841 155.508 210.654L155.541 221.683C155.543 222.497 154.889 223.16 154.083 223.163Z",
    fill: "#A0335D"
  }))), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4303 223.368L152.133 223.166C152.94 223.166 153.592 222.502 153.592 221.688L153.559 210.659C153.559 209.846 152.9 209.188 152.094 209.188L83.3909 209.389L83.4303 223.368Z",
    fill: "#FFE6D6"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7913 209.397C81.7848 207.658 81.7848 206.771 81.7848 206.771L119.237 206.662L119.293 225.892L81.8405 226.001C81.8405 226.001 81.8405 225.105 81.834 223.376H83.4304L83.3911 209.394H81.7946L81.7913 209.397Z",
    fill: "#A0335D"
  }))), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M120.136 209.277L83.3951 209.387L83.4363 223.365L120.177 223.255L120.136 209.277Z",
    fill: "#CEB6AA"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M120.136 209.277L83.3951 209.387L83.4363 223.365L120.177 223.255L120.136 209.277Z",
    fill: "#CEB6AA"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M118.89 209.287L152.094 209.191C152.9 209.191 153.556 209.846 153.559 210.663L153.566 212.753C153.566 211.94 152.907 211.281 152.101 211.281L118.896 211.377L118.89 209.287Z",
    fill: "#CEB6AA"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M151.088 213.134C151.088 213.134 150.117 213.045 148.665 212.982C147.938 212.959 147.092 212.909 146.184 212.903C145.276 212.893 144.305 212.883 143.338 212.873C142.368 212.89 141.401 212.903 140.493 212.919C139.585 212.933 138.736 212.989 138.011 213.015C136.559 213.088 135.589 213.184 135.589 213.184C135.589 213.184 136.559 213.273 138.011 213.339C138.739 213.359 139.585 213.412 140.493 213.419C141.401 213.429 142.371 213.439 143.338 213.448C144.309 213.432 145.276 213.415 146.184 213.402C147.092 213.389 147.941 213.333 148.665 213.306C150.117 213.234 151.088 213.138 151.088 213.138V213.134Z",
    fill: "#CEB6AA"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M146.495 220.691C146.495 220.691 145.075 220.611 142.945 220.542C141.879 220.519 140.637 220.492 139.306 220.466C137.975 220.456 136.556 220.449 135.136 220.439C133.717 220.456 132.297 220.473 130.966 220.489C129.635 220.502 128.393 220.562 127.328 220.588C125.197 220.671 123.777 220.76 123.777 220.76C123.777 220.76 125.197 220.84 127.328 220.912C128.393 220.932 129.635 220.982 130.966 220.988C132.297 220.995 133.717 221.005 135.136 221.015C136.556 220.998 137.975 220.982 139.306 220.965C140.637 220.929 141.879 220.896 142.945 220.866C145.075 220.783 146.495 220.694 146.495 220.694V220.691Z",
    fill: "#CEB6AA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M148.793 215.744C148.793 215.744 147.373 215.664 145.242 215.595C144.177 215.572 142.935 215.545 141.604 215.519C140.273 215.509 138.853 215.502 137.434 215.492C136.014 215.509 134.595 215.525 133.264 215.542C131.933 215.555 130.691 215.615 129.625 215.641C127.495 215.724 126.075 215.813 126.075 215.813C126.075 215.813 127.495 215.892 129.625 215.965C130.691 215.985 131.933 216.035 133.264 216.041C134.595 216.048 136.014 216.058 137.434 216.068C138.853 216.051 140.273 216.035 141.604 216.018C142.935 215.982 144.177 215.949 145.242 215.919C147.373 215.836 148.793 215.747 148.793 215.747V215.744Z",
    fill: "#CEB6AA"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M118.326 218.846C118.326 218.846 116.513 218.746 113.796 218.677C112.435 218.65 110.852 218.624 109.154 218.591C107.456 218.581 105.643 218.574 103.83 218.564C102.017 218.584 100.208 218.604 98.5064 218.624C96.8083 218.641 95.2217 218.707 93.8646 218.736C91.147 218.822 89.3342 218.932 89.3342 218.932C89.3342 218.932 91.147 219.031 93.8646 219.1C95.225 219.123 96.8083 219.18 98.5064 219.186C100.204 219.196 102.017 219.203 103.83 219.213C105.643 219.193 107.452 219.173 109.154 219.153C110.852 219.113 112.438 219.074 113.796 219.041C116.513 218.955 118.326 218.846 118.326 218.846Z",
    fill: "#B29B93"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3623 212.813C97.3623 212.813 96.5887 212.747 95.425 212.7C94.2612 212.648 92.714 212.631 91.1634 212.621C89.6129 212.641 88.0656 212.664 86.9018 212.727C85.7414 212.78 84.9645 212.853 84.9645 212.853C84.9645 212.853 85.7381 212.919 86.9018 212.965C88.0656 213.018 89.6129 213.034 91.1634 213.044C92.714 213.025 94.2612 213.001 95.425 212.939C96.5854 212.886 97.3623 212.813 97.3623 212.813Z",
    fill: "#B29B93"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M112.54 221.289C112.54 221.289 111.357 221.21 109.58 221.151C107.803 221.084 105.436 221.065 103.073 221.055C100.706 221.078 98.3393 221.111 96.5658 221.187C94.7924 221.256 93.6089 221.342 93.6089 221.342C93.6089 221.342 94.7923 221.422 96.5691 221.481C98.3458 221.547 100.713 221.564 103.076 221.577C105.443 221.551 107.81 221.521 109.583 221.445C111.357 221.375 112.54 221.289 112.54 221.289Z",
    fill: "#B29B93"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M111.98 215.252C111.98 215.252 110.796 215.173 109.02 215.113C107.243 215.047 104.876 215.027 102.513 215.018C100.146 215.041 97.779 215.074 96.0055 215.15C94.232 215.219 93.0486 215.305 93.0486 215.305C93.0486 215.305 94.232 215.385 96.0088 215.444C97.7855 215.51 100.152 215.527 102.516 215.54C104.883 215.514 107.249 215.484 109.023 215.408C110.796 215.338 111.98 215.252 111.98 215.252Z",
    fill: "#B29B93"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M120.136 209.277L83.3951 209.387L83.4012 211.447L120.142 211.337L120.136 209.277Z",
    fill: "#B29B93"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M144.849 211.44C143.908 213.642 143.607 220.008 143.564 223.249H159.689C159.716 220.104 159.476 213.533 158.48 211.165C157.08 207.832 153.54 205.735 153.54 204.931C153.54 204.128 156.375 202.216 157.929 199.336C159.214 196.958 159.666 192.289 159.693 188.74H143.567C143.541 192.318 143.987 196.981 145.157 199.415C146.478 202.16 149.717 203.979 149.717 204.935C149.717 205.89 146.278 208.103 144.849 211.44ZM144.492 222.333C144.587 218.229 144.987 213.44 145.685 211.803C146.449 210.011 147.908 208.51 148.97 207.415C150.002 206.347 150.629 205.705 150.629 204.935C150.629 204.111 149.934 203.46 148.878 202.478C147.878 201.548 146.636 200.388 145.977 199.015C144.993 196.971 144.531 193.003 144.482 189.66H158.768C158.676 192.977 158.211 196.905 157.132 198.899C156.326 200.394 155.146 201.611 154.198 202.59C153.222 203.599 152.635 204.207 152.635 204.935C152.635 205.662 153.185 206.162 154.185 207.111C155.316 208.185 156.867 209.657 157.65 211.522C158.46 213.454 158.765 218.824 158.788 222.333H144.498H144.492Z",
    fill: "url(#paint35_linear_10512_2732)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M158.781 222.333C158.758 218.821 158.453 213.451 157.644 211.523C156.86 209.658 155.313 208.186 154.179 207.111C153.179 206.162 152.628 205.64 152.628 204.935C152.628 204.231 153.218 203.599 154.192 202.591C155.139 201.612 156.319 200.395 157.126 198.9C158.204 196.903 158.673 192.977 158.762 189.66H144.475C144.525 193.004 144.987 196.972 145.97 199.016C146.629 200.388 147.872 201.549 148.871 202.481C149.927 203.464 150.622 204.115 150.622 204.939C150.622 205.762 149.996 206.354 148.963 207.419C147.901 208.513 146.442 210.015 145.679 211.807C144.98 213.444 144.58 218.233 144.485 222.337H158.775L158.781 222.333Z",
    fill: "url(#paint36_linear_10512_2732)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M143.495 225.998H159.761C160.08 225.998 160.338 225.737 160.338 225.416V222.913C160.338 222.591 160.08 222.331 159.761 222.331H143.495C143.177 222.331 142.918 222.591 142.918 222.913V225.416C142.918 225.737 143.177 225.998 143.495 225.998Z",
    fill: "url(#paint37_linear_10512_2732)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M143.495 189.68H159.761C160.08 189.68 160.338 189.419 160.338 189.098V186.594C160.338 186.273 160.08 186.012 159.761 186.012H143.495C143.177 186.012 142.918 186.273 142.918 186.594V189.098C142.918 189.419 143.177 189.68 143.495 189.68Z",
    fill: "url(#paint38_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M143.469 222.334H149.763V222.985C149.763 223.323 150.009 223.594 150.314 223.594H160.338V225.39C160.338 225.727 160.092 225.998 159.787 225.998H143.469C143.164 225.998 142.918 225.724 142.918 225.39V222.942C142.918 222.605 143.164 222.334 143.469 222.334Z",
    fill: "#463332"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M143.469 186.012H159.787C160.092 186.012 160.338 186.286 160.338 186.62V188.38H150.314C150.009 188.38 149.763 188.654 149.763 188.988V189.676H143.469C143.164 189.676 142.918 189.401 142.918 189.067V186.62C142.918 186.283 143.164 186.012 143.469 186.012Z",
    fill: "#463332"
  }))), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M142.522 225.998H160.735C160.974 225.998 161.168 225.803 161.168 225.562V224.559C161.168 224.318 160.974 224.123 160.735 224.123H142.522C142.283 224.123 142.089 224.318 142.089 224.559V225.562C142.089 225.803 142.283 225.998 142.522 225.998Z",
    fill: "url(#paint39_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M142.502 224.125H149.347C149.117 224.125 148.934 224.33 148.934 224.581V225.544C148.934 225.795 149.117 226 149.347 226H142.502C142.273 226 142.089 225.795 142.089 225.544V224.581C142.089 224.33 142.273 224.125 142.502 224.125Z",
    fill: "#463332"
  }))), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M142.522 187.887H160.735C160.974 187.887 161.168 187.691 161.168 187.45V186.448C161.168 186.207 160.974 186.012 160.735 186.012H142.522C142.283 186.012 142.089 186.207 142.089 186.448V187.45C142.089 187.691 142.283 187.887 142.522 187.887Z",
    fill: "url(#paint40_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M149.717 204.931C149.717 203.975 146.478 202.156 145.157 199.411C143.984 196.977 143.538 192.315 143.567 188.736H159.692C159.686 189.487 159.663 190.287 159.614 191.104H149.583C149.583 191.104 149.081 197.077 150.265 200.651C151.1 203.175 151.553 204.107 151.553 205.235C151.553 206.363 148.976 208.069 149.291 223.245H143.567C143.607 220.004 143.908 213.638 144.852 211.436C146.278 208.096 149.72 205.883 149.72 204.931H149.717Z",
    fill: "#398191"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M142.502 186.012H149.347C149.117 186.012 148.934 186.217 148.934 186.468V187.43C148.934 187.682 149.117 187.887 149.347 187.887H142.502C142.273 187.887 142.089 187.682 142.089 187.43V186.468C142.089 186.217 142.273 186.012 142.502 186.012Z",
    fill: "#463332"
  }))), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M148.875 202.477C147.875 201.548 146.633 200.387 145.974 199.015C145.564 198.162 145.246 196.958 145.01 195.615H158.162C157.909 196.918 157.572 198.076 157.129 198.899C156.323 200.394 155.143 201.611 154.195 202.59C153.218 203.598 152.422 204.359 152.078 204.875C151.642 205.526 151.51 205.467 151.133 204.875C150.812 204.369 149.927 203.463 148.875 202.481V202.477Z",
    fill: "url(#paint41_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M145.154 196.339C145.105 196.101 145.056 195.863 145.01 195.615H158.162C158.113 195.863 158.06 196.105 158.004 196.339H145.154Z",
    fill: "#FFE675"
  }))), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M158.627 217.919C158.67 218.739 158.774 221.028 158.781 222.334H144.492C144.524 220.889 144.613 219.05 144.708 217.919C147.881 217.879 149.812 215.932 151.572 215.932C153.333 215.932 155.66 217.936 158.627 217.919Z",
    fill: "url(#paint42_linear_10512_2732)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M151.311 216.398C149.557 216.398 147.088 218.306 144.705 217.919C147.537 217.982 149.809 215.932 151.57 215.932C153.33 215.932 155.657 217.936 158.624 217.919C158.631 218.055 158.641 218.24 158.65 218.442C155.572 218.402 153.146 216.395 151.311 216.395V216.398Z",
    fill: "#FFE675"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M147 195.615C147.173 196.339 147.373 196.988 147.619 197.494C150.038 202.524 154.307 203.403 157.549 197.391C157.736 197.044 157.899 196.627 158.047 196.168C157.811 197.239 157.513 198.195 157.132 198.899C156.326 200.394 155.146 201.611 154.198 202.59C153.222 203.598 152.425 204.359 152.081 204.875C151.645 205.526 151.514 205.467 151.137 204.875C150.815 204.369 149.934 203.463 148.878 202.481C147.878 201.551 146.636 200.391 145.977 199.018C145.567 198.165 145.249 196.961 145.013 195.619H147.003L147 195.615Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M144.705 217.918C147.472 217.931 149.56 216.172 151.232 215.957C150.301 216.337 149.694 216.853 149.694 217.551C149.694 218.993 151.956 219.74 154.33 219.74C156.962 219.74 158.516 218.781 158.598 217.895C158.608 217.895 158.614 217.895 158.624 217.895C158.667 218.722 158.771 221.02 158.778 222.33H144.489C144.521 220.878 144.63 219.003 144.705 217.915V217.918Z",
    fill: "#AA2424"
  }))), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M151.628 207.223C151.864 207.223 152.054 207.031 152.054 206.793C152.054 206.556 151.864 206.363 151.628 206.363C151.393 206.363 151.202 206.556 151.202 206.793C151.202 207.031 151.393 207.223 151.628 207.223Z",
    fill: "#ED9C47"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M151.488 215.247C151.723 215.247 151.914 215.054 151.914 214.817C151.914 214.579 151.723 214.387 151.488 214.387C151.252 214.387 151.062 214.579 151.062 214.817C151.062 215.054 151.252 215.247 151.488 215.247Z",
    fill: "#ED9C47"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M150.871 209.832C150.871 210 151.005 210.136 151.173 210.136C151.34 210.136 151.474 210 151.474 209.832C151.474 209.663 151.34 209.527 151.173 209.527C151.005 209.527 150.871 209.663 150.871 209.832Z",
    fill: "#ED9C47"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M152.11 208.256C152.11 208.381 152.212 208.484 152.336 208.484C152.461 208.484 152.563 208.381 152.563 208.256C152.563 208.13 152.461 208.027 152.336 208.027C152.212 208.027 152.11 208.13 152.11 208.256Z",
    fill: "#ED9C47"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M151.428 213.669C151.553 213.669 151.655 213.567 151.655 213.441C151.655 213.315 151.553 213.213 151.428 213.213C151.303 213.213 151.202 213.315 151.202 213.441C151.202 213.567 151.303 213.669 151.428 213.669Z",
    fill: "#ED9C47"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M150.491 215.56C150.491 215.686 150.592 215.788 150.717 215.788C150.842 215.788 150.943 215.686 150.943 215.56C150.943 215.435 150.842 215.332 150.717 215.332C150.592 215.332 150.491 215.435 150.491 215.56Z",
    fill: "#ED9C47"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M152.31 215.701C152.31 215.827 152.412 215.929 152.536 215.929C152.661 215.929 152.763 215.827 152.763 215.701C152.763 215.575 152.661 215.473 152.536 215.473C152.412 215.473 152.31 215.575 152.31 215.701Z",
    fill: "#ED9C47"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M151.002 207.769C151.127 207.769 151.228 207.667 151.228 207.541C151.228 207.415 151.127 207.312 151.002 207.312C150.877 207.312 150.776 207.415 150.776 207.541C150.776 207.667 150.877 207.769 151.002 207.769Z",
    fill: "#ED9C47"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M151.373 210.662C151.373 210.787 151.474 210.89 151.599 210.89C151.724 210.89 151.825 210.787 151.825 210.662C151.825 210.536 151.724 210.434 151.599 210.434C151.474 210.434 151.373 210.536 151.373 210.662Z",
    fill: "#ED9C47"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M151.602 206.367C151.425 206.407 151.294 206.562 151.294 206.754C151.294 206.972 151.471 207.151 151.687 207.151C151.835 207.151 151.966 207.068 152.031 206.946C151.972 207.111 151.815 207.227 151.631 207.227C151.395 207.227 151.205 207.035 151.205 206.797C151.205 206.569 151.382 206.384 151.605 206.367H151.602Z",
    fill: "#AA2424"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M151.34 214.414C151.235 214.484 151.166 214.606 151.166 214.741C151.166 214.96 151.343 215.138 151.559 215.138C151.7 215.138 151.821 215.066 151.89 214.953C151.835 215.125 151.674 215.247 151.487 215.247C151.251 215.247 151.061 215.056 151.061 214.818C151.061 214.632 151.179 214.474 151.343 214.414H151.34Z",
    fill: "#AA2424"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M151.117 209.531C151.018 209.574 150.95 209.673 150.95 209.786C150.95 209.941 151.074 210.067 151.228 210.067C151.317 210.067 151.395 210.024 151.445 209.961C151.395 210.064 151.294 210.136 151.172 210.136C151.005 210.136 150.871 210.001 150.871 209.832C150.871 209.683 150.976 209.561 151.117 209.535V209.531Z",
    fill: "#AA2424"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M152.304 208.031C152.232 208.064 152.182 208.137 152.182 208.223C152.182 208.339 152.277 208.435 152.392 208.435C152.448 208.435 152.494 208.415 152.533 208.378C152.494 208.445 152.422 208.488 152.34 208.488C152.215 208.488 152.114 208.385 152.114 208.259C152.114 208.144 152.195 208.051 152.304 208.035V208.031Z",
    fill: "#AA2424"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M151.35 213.227C151.297 213.266 151.264 213.326 151.264 213.395C151.264 213.511 151.359 213.607 151.474 213.607C151.543 213.607 151.602 213.574 151.641 213.521C151.609 213.607 151.527 213.67 151.428 213.67C151.304 213.67 151.202 213.567 151.202 213.442C151.202 213.342 151.264 213.26 151.35 213.227Z",
    fill: "#AA2424"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M150.638 215.346C150.596 215.385 150.569 215.438 150.569 215.501C150.569 215.617 150.664 215.713 150.779 215.713C150.838 215.713 150.894 215.686 150.93 215.647C150.897 215.729 150.815 215.789 150.72 215.789C150.596 215.789 150.494 215.686 150.494 215.561C150.494 215.465 150.553 215.382 150.638 215.349V215.346Z",
    fill: "#AA2424"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M152.428 215.504C152.392 215.54 152.369 215.593 152.369 215.649C152.369 215.765 152.464 215.861 152.579 215.861C152.654 215.861 152.72 215.821 152.756 215.759C152.73 215.858 152.641 215.934 152.536 215.934C152.412 215.934 152.31 215.831 152.31 215.706C152.31 215.62 152.359 215.544 152.428 215.504Z",
    fill: "#AA2424"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M150.963 207.316C150.894 207.349 150.848 207.422 150.848 207.505C150.848 207.621 150.943 207.717 151.058 207.717C151.113 207.717 151.163 207.693 151.199 207.66C151.159 207.726 151.087 207.773 151.005 207.773C150.881 207.773 150.779 207.67 150.779 207.545C150.779 207.432 150.861 207.34 150.966 207.32L150.963 207.316Z",
    fill: "#AA2424"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M151.481 210.469C151.451 210.505 151.432 210.551 151.432 210.604C151.432 210.72 151.527 210.816 151.642 210.816C151.72 210.816 151.786 210.773 151.822 210.71C151.802 210.816 151.71 210.895 151.599 210.895C151.474 210.895 151.373 210.793 151.373 210.667C151.373 210.584 151.419 210.512 151.484 210.472L151.481 210.469Z",
    fill: "#AA2424"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M153.503 208.886C151.189 209.928 155.359 214.349 156.605 213.837C158.535 213.043 155.523 207.977 153.503 208.886Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M160.253 224.859C160.257 225.527 151.324 225.18 151.32 224.82C151.32 224.459 160.247 224.191 160.253 224.859Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.3
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M160.253 186.822C160.257 187.49 151.324 187.143 151.32 186.783C151.32 186.422 160.247 186.154 160.253 186.822Z",
    fill: "#FFF7E6"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.6
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M156.503 191.865C153.979 191.647 154.313 197.596 155.595 198.013C157.306 198.572 158.555 192.044 156.503 191.865Z",
    fill: "#FFF7E6"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M155.11 198.812C153.894 198.034 152.222 201.53 152.828 201.871C153.766 202.4 156.064 199.423 155.11 198.812Z",
    fill: "#FFF7E6"
  }))), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7 63.24C29.2867 63.24 28.0733 62.94 27.06 62.34C26.0467 61.7267 25.2667 60.88 24.72 59.8C24.1733 58.7067 23.9 57.4467 23.9 56.02C23.9 54.5933 24.1733 53.3333 24.72 52.24C25.2667 51.1467 26.0467 50.2933 27.06 49.68C28.0733 49.0667 29.2867 48.76 30.7 48.76C32.38 48.76 33.7533 49.18 34.82 50.02C35.9 50.8467 36.5733 52.0133 36.84 53.52H34.02C33.8467 52.76 33.4733 52.1667 32.9 51.74C32.34 51.3 31.5933 51.08 30.66 51.08C29.3667 51.08 28.3533 51.52 27.62 52.4C26.8867 53.28 26.52 54.4867 26.52 56.02C26.52 57.5533 26.8867 58.76 27.62 59.64C28.3533 60.5067 29.3667 60.94 30.66 60.94C31.5933 60.94 32.34 60.74 32.9 60.34C33.4733 59.9267 33.8467 59.36 34.02 58.64H36.84C36.5733 60.08 35.9 61.2067 34.82 62.02C33.7533 62.8333 32.38 63.24 30.7 63.24ZM42.5461 63.24C41.3061 63.24 40.3461 62.8533 39.6661 62.08C38.9994 61.3067 38.6661 60.1733 38.6661 58.68V53.08H41.2061V58.44C41.2061 59.2933 41.3794 59.9467 41.7261 60.4C42.0728 60.8533 42.6194 61.08 43.3661 61.08C44.0728 61.08 44.6528 60.8267 45.1061 60.32C45.5728 59.8133 45.8061 59.1067 45.8061 58.2V53.08H48.3661V63H46.1061L45.9061 61.32C45.5994 61.9067 45.1528 62.3733 44.5661 62.72C43.9928 63.0667 43.3194 63.24 42.5461 63.24ZM50.7741 63V53.08H53.0541L53.2941 54.94C53.6541 54.3 54.1407 53.7933 54.7541 53.42C55.3807 53.0333 56.1141 52.84 56.9541 52.84V55.54H56.2341C55.6741 55.54 55.1741 55.6267 54.7341 55.8C54.2941 55.9733 53.9474 56.2733 53.6941 56.7C53.4541 57.1267 53.3341 57.72 53.3341 58.48V63H50.7741ZM58.4838 63V53.08H60.7638L61.0038 54.94C61.3638 54.3 61.8504 53.7933 62.4638 53.42C63.0904 53.0333 63.8238 52.84 64.6638 52.84V55.54H63.9438C63.3838 55.54 62.8838 55.6267 62.4438 55.8C62.0038 55.9733 61.6571 56.2733 61.4038 56.7C61.1638 57.1267 61.0438 57.72 61.0438 58.48V63H58.4838ZM67.5734 51.54C67.1068 51.54 66.7201 51.4 66.4134 51.12C66.1201 50.84 65.9734 50.4867 65.9734 50.06C65.9734 49.6333 66.1201 49.2867 66.4134 49.02C66.7201 48.74 67.1068 48.6 67.5734 48.6C68.0401 48.6 68.4201 48.74 68.7134 49.02C69.0201 49.2867 69.1734 49.6333 69.1734 50.06C69.1734 50.4867 69.0201 50.84 68.7134 51.12C68.4201 51.4 68.0401 51.54 67.5734 51.54ZM66.2934 63V53.08H68.8534V63H66.2934ZM76.1655 63.24C75.1521 63.24 74.2588 63.02 73.4855 62.58C72.7121 62.14 72.0988 61.5267 71.6455 60.74C71.2055 59.9533 70.9855 59.0533 70.9855 58.04C70.9855 57.0267 71.2055 56.1267 71.6455 55.34C72.0988 54.5533 72.7121 53.94 73.4855 53.5C74.2588 53.06 75.1521 52.84 76.1655 52.84C77.4321 52.84 78.4988 53.1733 79.3655 53.84C80.2321 54.4933 80.7855 55.4 81.0255 56.56H78.3255C78.1921 56.08 77.9255 55.7067 77.5255 55.44C77.1388 55.16 76.6788 55.02 76.1455 55.02C75.4388 55.02 74.8388 55.2867 74.3455 55.82C73.8521 56.3533 73.6055 57.0933 73.6055 58.04C73.6055 58.9867 73.8521 59.7267 74.3455 60.26C74.8388 60.7933 75.4388 61.06 76.1455 61.06C76.6788 61.06 77.1388 60.9267 77.5255 60.66C77.9255 60.3933 78.1921 60.0133 78.3255 59.52H81.0255C80.7855 60.64 80.2321 61.54 79.3655 62.22C78.4988 62.9 77.4321 63.24 76.1655 63.24ZM86.7977 63.24C85.5577 63.24 84.5977 62.8533 83.9177 62.08C83.251 61.3067 82.9177 60.1733 82.9177 58.68V53.08H85.4577V58.44C85.4577 59.2933 85.631 59.9467 85.9777 60.4C86.3243 60.8533 86.871 61.08 87.6177 61.08C88.3243 61.08 88.9043 60.8267 89.3577 60.32C89.8243 59.8133 90.0577 59.1067 90.0577 58.2V53.08H92.6177V63H90.3577L90.1577 61.32C89.851 61.9067 89.4043 62.3733 88.8177 62.72C88.2443 63.0667 87.571 63.24 86.7977 63.24ZM95.0256 63V48.6H97.5856V63H95.0256ZM103.701 63.24C102.461 63.24 101.501 62.8533 100.821 62.08C100.155 61.3067 99.8214 60.1733 99.8214 58.68V53.08H102.361V58.44C102.361 59.2933 102.535 59.9467 102.881 60.4C103.228 60.8533 103.775 61.08 104.521 61.08C105.228 61.08 105.808 60.8267 106.261 60.32C106.728 59.8133 106.961 59.1067 106.961 58.2V53.08H109.521V63H107.261L107.061 61.32C106.755 61.9067 106.308 62.3733 105.721 62.72C105.148 63.0667 104.475 63.24 103.701 63.24ZM111.929 63V53.08H114.189L114.409 54.42C114.729 53.94 115.149 53.56 115.669 53.28C116.203 52.9867 116.816 52.84 117.509 52.84C119.043 52.84 120.129 53.4333 120.769 54.62C121.129 54.0733 121.609 53.64 122.209 53.32C122.823 53 123.489 52.84 124.209 52.84C125.503 52.84 126.496 53.2267 127.189 54C127.883 54.7733 128.229 55.9067 128.229 57.4V63H125.669V57.64C125.669 56.7867 125.503 56.1333 125.169 55.68C124.849 55.2267 124.349 55 123.669 55C122.976 55 122.416 55.2533 121.989 55.76C121.576 56.2667 121.369 56.9733 121.369 57.88V63H118.809V57.64C118.809 56.7867 118.643 56.1333 118.309 55.68C117.976 55.2267 117.463 55 116.769 55C116.089 55 115.536 55.2533 115.109 55.76C114.696 56.2667 114.489 56.9733 114.489 57.88V63H111.929ZM139.525 63.22C138.499 63.22 137.605 63.0467 136.845 62.7C136.085 62.34 135.492 61.84 135.065 61.2C134.652 60.56 134.445 59.8133 134.445 58.96C134.445 58.0533 134.699 57.2333 135.205 56.5C135.712 55.7667 136.465 55.18 137.465 54.74C137.065 54.2733 136.779 53.8333 136.605 53.42C136.432 53.0067 136.345 52.5667 136.345 52.1C136.345 51.46 136.505 50.8933 136.825 50.4C137.145 49.8933 137.599 49.4933 138.185 49.2C138.785 48.9067 139.499 48.76 140.325 48.76C141.165 48.76 141.879 48.9133 142.465 49.22C143.052 49.5267 143.492 49.94 143.785 50.46C144.092 50.98 144.232 51.56 144.205 52.2H141.765C141.765 51.7067 141.619 51.34 141.325 51.1C141.045 50.8467 140.705 50.72 140.305 50.72C139.852 50.72 139.485 50.8467 139.205 51.1C138.939 51.3533 138.805 51.68 138.805 52.08C138.805 52.4133 138.912 52.7533 139.125 53.1C139.339 53.4467 139.652 53.8467 140.065 54.3L143.985 58.18C144.265 57.7267 144.559 57.2 144.865 56.6L145.305 55.72H147.925L147.225 57.08C146.692 58.16 146.159 59.0733 145.625 59.82L148.845 63H145.785L144.225 61.44C143.545 62.0667 142.819 62.52 142.045 62.8C141.285 63.08 140.445 63.22 139.525 63.22ZM136.925 58.8C136.925 59.4533 137.165 60.0067 137.645 60.46C138.139 60.9 138.792 61.12 139.605 61.12C140.765 61.12 141.772 60.7067 142.625 59.88L138.925 56.22C138.245 56.5133 137.739 56.88 137.405 57.32C137.085 57.76 136.925 58.2533 136.925 58.8ZM24.36 89V75H29.54C30.66 75 31.5867 75.1867 32.32 75.56C33.0533 75.9333 33.6 76.4467 33.96 77.1C34.32 77.7533 34.5 78.4867 34.5 79.3C34.5 80.0733 34.3267 80.7867 33.98 81.44C33.6333 82.08 33.0933 82.6 32.36 83C31.6267 83.3867 30.6867 83.58 29.54 83.58H26.92V89H24.36ZM26.92 81.5H29.38C30.2733 81.5 30.9133 81.3067 31.3 80.92C31.7 80.52 31.9 79.98 31.9 79.3C31.9 78.6067 31.7 78.0667 31.3 77.68C30.9133 77.28 30.2733 77.08 29.38 77.08H26.92V81.5ZM40.5406 89.24C39.5406 89.24 38.654 89.0267 37.8806 88.6C37.1073 88.1733 36.5006 87.5733 36.0606 86.8C35.6206 86.0267 35.4006 85.1333 35.4006 84.12C35.4006 83.0933 35.614 82.18 36.0406 81.38C36.4806 80.58 37.0806 79.96 37.8406 79.52C38.614 79.0667 39.5206 78.84 40.5606 78.84C41.534 78.84 42.394 79.0533 43.1406 79.48C43.8873 79.9067 44.4673 80.4933 44.8806 81.24C45.3073 81.9733 45.5206 82.7933 45.5206 83.7C45.5206 83.8467 45.514 84 45.5006 84.16C45.5006 84.32 45.494 84.4867 45.4806 84.66H37.9406C37.994 85.4333 38.2606 86.04 38.7406 86.48C39.234 86.92 39.8273 87.14 40.5206 87.14C41.0406 87.14 41.474 87.0267 41.8206 86.8C42.1806 86.56 42.4473 86.2533 42.6206 85.88H45.2206C45.034 86.5067 44.7206 87.08 44.2806 87.6C43.854 88.1067 43.3206 88.5067 42.6806 88.8C42.054 89.0933 41.3406 89.24 40.5406 89.24ZM40.5606 80.92C39.934 80.92 39.3806 81.1 38.9006 81.46C38.4206 81.8067 38.114 82.34 37.9806 83.06H42.9206C42.8806 82.4067 42.6406 81.8867 42.2006 81.5C41.7606 81.1133 41.214 80.92 40.5606 80.92ZM52.0137 89.24C51.0804 89.24 50.2471 89.0133 49.5137 88.56C48.7804 88.1067 48.2004 87.4867 47.7737 86.7C47.3471 85.9133 47.1337 85.02 47.1337 84.02C47.1337 83.02 47.3471 82.1333 47.7737 81.36C48.2004 80.5733 48.7804 79.96 49.5137 79.52C50.2471 79.0667 51.0804 78.84 52.0137 78.84C52.7604 78.84 53.4137 78.98 53.9738 79.26C54.5338 79.54 54.9871 79.9333 55.3337 80.44V74.6H57.8937V89H55.6137L55.3337 87.58C55.0138 88.02 54.5871 88.4067 54.0537 88.74C53.5337 89.0733 52.8537 89.24 52.0137 89.24ZM52.5537 87C53.3804 87 54.0538 86.7267 54.5738 86.18C55.1071 85.62 55.3737 84.9067 55.3737 84.04C55.3737 83.1733 55.1071 82.4667 54.5738 81.92C54.0538 81.36 53.3804 81.08 52.5537 81.08C51.7404 81.08 51.0671 81.3533 50.5337 81.9C50.0004 82.4467 49.7337 83.1533 49.7337 84.02C49.7337 84.8867 50.0004 85.6 50.5337 86.16C51.0671 86.72 51.7404 87 52.5537 87ZM63.7006 89.24C62.8473 89.24 62.1473 89.1067 61.6006 88.84C61.054 88.56 60.6473 88.1933 60.3806 87.74C60.114 87.2867 59.9806 86.7867 59.9806 86.24C59.9806 85.32 60.3406 84.5733 61.0606 84C61.7806 83.4267 62.8606 83.14 64.3006 83.14H66.8206V82.9C66.8206 82.22 66.6273 81.72 66.2406 81.4C65.854 81.08 65.374 80.92 64.8006 80.92C64.2806 80.92 63.8273 81.0467 63.4406 81.3C63.054 81.54 62.814 81.9 62.7206 82.38H60.2206C60.2873 81.66 60.5273 81.0333 60.9406 80.5C61.3673 79.9667 61.914 79.56 62.5806 79.28C63.2473 78.9867 63.994 78.84 64.8206 78.84C66.234 78.84 67.3473 79.1933 68.1606 79.9C68.974 80.6067 69.3806 81.6067 69.3806 82.9V89H67.2006L66.9606 87.4C66.6673 87.9333 66.254 88.3733 65.7206 88.72C65.2006 89.0667 64.5273 89.24 63.7006 89.24ZM64.2806 87.24C65.014 87.24 65.5806 87 65.9806 86.52C66.394 86.04 66.654 85.4467 66.7606 84.74H64.5806C63.9006 84.74 63.414 84.8667 63.1206 85.12C62.8273 85.36 62.6806 85.66 62.6806 86.02C62.6806 86.4067 62.8273 86.7067 63.1206 86.92C63.414 87.1333 63.8006 87.24 64.2806 87.24ZM75.8036 86.04C75.3236 86.04 74.8769 85.9867 74.4636 85.88L73.7236 86.62C73.9503 86.74 74.2569 86.84 74.6436 86.92C75.0303 87 75.6569 87.08 76.5236 87.16C77.8436 87.28 78.8036 87.5933 79.4036 88.1C80.0036 88.6067 80.3036 89.3067 80.3036 90.2C80.3036 90.7867 80.1436 91.34 79.8236 91.86C79.5036 92.3933 79.0103 92.82 78.3436 93.14C77.6769 93.4733 76.8236 93.64 75.7836 93.64C74.3703 93.64 73.2303 93.3733 72.3636 92.84C71.4969 92.32 71.0636 91.5333 71.0636 90.48C71.0636 89.5867 71.4969 88.8133 72.3636 88.16C72.0969 88.04 71.8636 87.9133 71.6636 87.78C71.4769 87.6467 71.3103 87.5067 71.1636 87.36V86.9L72.9036 85.06C72.1303 84.38 71.7436 83.5067 71.7436 82.44C71.7436 81.7733 71.9036 81.1667 72.2236 80.62C72.5569 80.0733 73.0236 79.64 73.6236 79.32C74.2236 79 74.9503 78.84 75.8036 78.84C76.3636 78.84 76.8836 78.92 77.3636 79.08H81.1236V80.64L79.4236 80.76C79.6903 81.2667 79.8236 81.8267 79.8236 82.44C79.8236 83.1067 79.6636 83.7133 79.3436 84.26C79.0236 84.8067 78.5569 85.24 77.9436 85.56C77.3436 85.88 76.6303 86.04 75.8036 86.04ZM75.8036 84.08C76.3236 84.08 76.7503 83.94 77.0836 83.66C77.4303 83.38 77.6036 82.98 77.6036 82.46C77.6036 81.94 77.4303 81.54 77.0836 81.26C76.7503 80.98 76.3236 80.84 75.8036 80.84C75.2569 80.84 74.8169 80.98 74.4836 81.26C74.1503 81.54 73.9836 81.94 73.9836 82.46C73.9836 82.98 74.1503 83.38 74.4836 83.66C74.8169 83.94 75.2569 84.08 75.8036 84.08ZM73.4036 90.22C73.4036 90.7133 73.6303 91.08 74.0836 91.32C74.5503 91.5733 75.1169 91.7 75.7836 91.7C76.4236 91.7 76.9436 91.5667 77.3436 91.3C77.7436 91.0467 77.9436 90.7 77.9436 90.26C77.9436 89.9 77.8103 89.6 77.5436 89.36C77.2903 89.12 76.7769 88.9733 76.0036 88.92C75.4569 88.88 74.9503 88.82 74.4836 88.74C74.0969 88.9533 73.8169 89.1867 73.6436 89.44C73.4836 89.6933 73.4036 89.9533 73.4036 90.22ZM87.1397 89.24C86.1797 89.24 85.313 89.02 84.5397 88.58C83.7797 88.14 83.173 87.5333 82.7197 86.76C82.2797 85.9733 82.0597 85.0667 82.0597 84.04C82.0597 83.0133 82.2864 82.1133 82.7397 81.34C83.193 80.5533 83.7997 79.94 84.5597 79.5C85.333 79.06 86.1997 78.84 87.1597 78.84C88.1064 78.84 88.9597 79.06 89.7197 79.5C90.493 79.94 91.0997 80.5533 91.5397 81.34C91.993 82.1133 92.2197 83.0133 92.2197 84.04C92.2197 85.0667 91.993 85.9733 91.5397 86.76C91.0997 87.5333 90.493 88.14 89.7197 88.58C88.9464 89.02 88.0864 89.24 87.1397 89.24ZM87.1397 87.02C87.8064 87.02 88.3864 86.7733 88.8797 86.28C89.373 85.7733 89.6197 85.0267 89.6197 84.04C89.6197 83.0533 89.373 82.3133 88.8797 81.82C88.3864 81.3133 87.813 81.06 87.1597 81.06C86.4797 81.06 85.893 81.3133 85.3997 81.82C84.9197 82.3133 84.6797 83.0533 84.6797 84.04C84.6797 85.0267 84.9197 85.7733 85.3997 86.28C85.893 86.7733 86.473 87.02 87.1397 87.02ZM97.8636 86.04C97.3836 86.04 96.9369 85.9867 96.5236 85.88L95.7836 86.62C96.0103 86.74 96.3169 86.84 96.7036 86.92C97.0903 87 97.7169 87.08 98.5836 87.16C99.9036 87.28 100.864 87.5933 101.464 88.1C102.064 88.6067 102.364 89.3067 102.364 90.2C102.364 90.7867 102.204 91.34 101.884 91.86C101.564 92.3933 101.07 92.82 100.404 93.14C99.7369 93.4733 98.8836 93.64 97.8436 93.64C96.4303 93.64 95.2903 93.3733 94.4236 92.84C93.5569 92.32 93.1236 91.5333 93.1236 90.48C93.1236 89.5867 93.5569 88.8133 94.4236 88.16C94.1569 88.04 93.9236 87.9133 93.7236 87.78C93.5369 87.6467 93.3703 87.5067 93.2236 87.36V86.9L94.9636 85.06C94.1903 84.38 93.8036 83.5067 93.8036 82.44C93.8036 81.7733 93.9636 81.1667 94.2836 80.62C94.6169 80.0733 95.0836 79.64 95.6836 79.32C96.2836 79 97.0103 78.84 97.8636 78.84C98.4236 78.84 98.9436 78.92 99.4236 79.08H103.184V80.64L101.484 80.76C101.75 81.2667 101.884 81.8267 101.884 82.44C101.884 83.1067 101.724 83.7133 101.404 84.26C101.084 84.8067 100.617 85.24 100.004 85.56C99.4036 85.88 98.6903 86.04 97.8636 86.04ZM97.8636 84.08C98.3836 84.08 98.8103 83.94 99.1436 83.66C99.4903 83.38 99.6636 82.98 99.6636 82.46C99.6636 81.94 99.4903 81.54 99.1436 81.26C98.8103 80.98 98.3836 80.84 97.8636 80.84C97.3169 80.84 96.8769 80.98 96.5436 81.26C96.2103 81.54 96.0436 81.94 96.0436 82.46C96.0436 82.98 96.2103 83.38 96.5436 83.66C96.8769 83.94 97.3169 84.08 97.8636 84.08ZM95.4636 90.22C95.4636 90.7133 95.6903 91.08 96.1436 91.32C96.6103 91.5733 97.1769 91.7 97.8436 91.7C98.4836 91.7 99.0036 91.5667 99.4036 91.3C99.8036 91.0467 100.004 90.7 100.004 90.26C100.004 89.9 99.8703 89.6 99.6036 89.36C99.3503 89.12 98.8369 88.9733 98.0636 88.92C97.5169 88.88 97.0103 88.82 96.5436 88.74C96.1569 88.9533 95.8769 89.1867 95.7036 89.44C95.5436 89.6933 95.4636 89.9533 95.4636 90.22ZM106.07 93.4L108.37 88.34H107.77L103.91 79.08H106.69L109.47 86.06L112.37 79.08H115.09L108.79 93.4H106.07ZM29.14 115.24C28.1133 115.24 27.2067 115.067 26.42 114.72C25.6333 114.36 25.0133 113.853 24.56 113.2C24.1067 112.533 23.8733 111.727 23.86 110.78H26.56C26.5867 111.433 26.82 111.987 27.26 112.44C27.7133 112.88 28.3333 113.1 29.12 113.1C29.8 113.1 30.34 112.94 30.74 112.62C31.14 112.287 31.34 111.847 31.34 111.3C31.34 110.727 31.16 110.28 30.8 109.96C30.4533 109.64 29.9867 109.38 29.4 109.18C28.8133 108.98 28.1867 108.767 27.52 108.54C26.44 108.167 25.6133 107.687 25.04 107.1C24.48 106.513 24.2 105.733 24.2 104.76C24.1867 103.933 24.38 103.227 24.78 102.64C25.1933 102.04 25.7533 101.58 26.46 101.26C27.1667 100.927 27.98 100.76 28.9 100.76C29.8333 100.76 30.6533 100.927 31.36 101.26C32.08 101.593 32.64 102.06 33.04 102.66C33.4533 103.26 33.6733 103.973 33.7 104.8H30.96C30.9467 104.307 30.7533 103.873 30.38 103.5C30.02 103.113 29.5133 102.92 28.86 102.92C28.3 102.907 27.8267 103.047 27.44 103.34C27.0667 103.62 26.88 104.033 26.88 104.58C26.88 105.047 27.0267 105.42 27.32 105.7C27.6133 105.967 28.0133 106.193 28.52 106.38C29.0267 106.567 29.6067 106.767 30.26 106.98C30.9533 107.22 31.5867 107.5 32.16 107.82C32.7333 108.14 33.1933 108.567 33.54 109.1C33.8867 109.62 34.06 110.293 34.06 111.12C34.06 111.853 33.8733 112.533 33.5 113.16C33.1267 113.787 32.5733 114.293 31.84 114.68C31.1067 115.053 30.2067 115.24 29.14 115.24ZM40.7736 115.24C39.8136 115.24 38.9469 115.02 38.1736 114.58C37.4136 114.14 36.8069 113.533 36.3536 112.76C35.9136 111.973 35.6936 111.067 35.6936 110.04C35.6936 109.013 35.9203 108.113 36.3736 107.34C36.8269 106.553 37.4336 105.94 38.1936 105.5C38.9669 105.06 39.8336 104.84 40.7936 104.84C41.7403 104.84 42.5936 105.06 43.3536 105.5C44.1269 105.94 44.7336 106.553 45.1736 107.34C45.6269 108.113 45.8536 109.013 45.8536 110.04C45.8536 111.067 45.6269 111.973 45.1736 112.76C44.7336 113.533 44.1269 114.14 43.3536 114.58C42.5803 115.02 41.7203 115.24 40.7736 115.24ZM40.7736 113.02C41.4403 113.02 42.0203 112.773 42.5136 112.28C43.0069 111.773 43.2536 111.027 43.2536 110.04C43.2536 109.053 43.0069 108.313 42.5136 107.82C42.0203 107.313 41.4469 107.06 40.7936 107.06C40.1136 107.06 39.5269 107.313 39.0336 107.82C38.5536 108.313 38.3136 109.053 38.3136 110.04C38.3136 111.027 38.5536 111.773 39.0336 112.28C39.5269 112.773 40.1069 113.02 40.7736 113.02ZM47.9225 115V100.6H50.4825V115H47.9225ZM56.5983 115.24C55.3583 115.24 54.3983 114.853 53.7183 114.08C53.0516 113.307 52.7183 112.173 52.7183 110.68V105.08H55.2583V110.44C55.2583 111.293 55.4316 111.947 55.7783 112.4C56.1249 112.853 56.6716 113.08 57.4183 113.08C58.1249 113.08 58.7049 112.827 59.1583 112.32C59.6249 111.813 59.8583 111.107 59.8583 110.2V105.08H62.4183V115H60.1583L59.9583 113.32C59.6516 113.907 59.2049 114.373 58.6183 114.72C58.0449 115.067 57.3716 115.24 56.5983 115.24ZM69.2462 115C68.2062 115 67.3729 114.747 66.7462 114.24C66.1196 113.733 65.8062 112.833 65.8062 111.54V107.22H64.1062V105.08H65.8062L66.1062 102.42H68.3662V105.08H71.0462V107.22H68.3662V111.56C68.3662 112.04 68.4662 112.373 68.6662 112.56C68.8796 112.733 69.2396 112.82 69.7462 112.82H70.9862V115H69.2462ZM74.4042 103.54C73.9376 103.54 73.5509 103.4 73.2442 103.12C72.9509 102.84 72.8042 102.487 72.8042 102.06C72.8042 101.633 72.9509 101.287 73.2442 101.02C73.5509 100.74 73.9376 100.6 74.4042 100.6C74.8709 100.6 75.2509 100.74 75.5442 101.02C75.8509 101.287 76.0042 101.633 76.0042 102.06C76.0042 102.487 75.8509 102.84 75.5442 103.12C75.2509 103.4 74.8709 103.54 74.4042 103.54ZM73.1242 115V105.08H75.6842V115H73.1242ZM82.8963 115.24C81.9363 115.24 81.0696 115.02 80.2963 114.58C79.5363 114.14 78.9296 113.533 78.4763 112.76C78.0363 111.973 77.8163 111.067 77.8163 110.04C77.8163 109.013 78.0429 108.113 78.4963 107.34C78.9496 106.553 79.5563 105.94 80.3163 105.5C81.0896 105.06 81.9563 104.84 82.9163 104.84C83.8629 104.84 84.7163 105.06 85.4763 105.5C86.2496 105.94 86.8563 106.553 87.2963 107.34C87.7496 108.113 87.9763 109.013 87.9763 110.04C87.9763 111.067 87.7496 111.973 87.2963 112.76C86.8563 113.533 86.2496 114.14 85.4763 114.58C84.7029 115.02 83.8429 115.24 82.8963 115.24ZM82.8963 113.02C83.5629 113.02 84.1429 112.773 84.6363 112.28C85.1296 111.773 85.3763 111.027 85.3763 110.04C85.3763 109.053 85.1296 108.313 84.6363 107.82C84.1429 107.313 83.5696 107.06 82.9163 107.06C82.2363 107.06 81.6496 107.313 81.1563 107.82C80.6763 108.313 80.4363 109.053 80.4363 110.04C80.4363 111.027 80.6763 111.773 81.1563 112.28C81.6496 112.773 82.2296 113.02 82.8963 113.02ZM90.0452 115V105.08H92.3052L92.5052 106.76C92.8118 106.173 93.2518 105.707 93.8252 105.36C94.4118 105.013 95.0985 104.84 95.8852 104.84C97.1118 104.84 98.0652 105.227 98.7452 106C99.4252 106.773 99.7652 107.907 99.7652 109.4V115H97.2052V109.64C97.2052 108.787 97.0318 108.133 96.6852 107.68C96.3385 107.227 95.7985 107 95.0652 107C94.3452 107 93.7518 107.253 93.2852 107.76C92.8318 108.267 92.6052 108.973 92.6052 109.88V115H90.0452Z",
    fill: "#FFB900"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10512_2732)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint43_linear_10512_2732)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 133,
    width: 38,
    height: 22,
    rx: 11,
    fill: "url(#paint44_linear_10512_2732)"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3624 147.851C44.1258 147.613 44.1258 147.228 44.3624 146.989L46.7109 144.612H37.5053C37.1715 144.612 36.8985 144.337 36.8985 144.001C36.8985 143.665 37.1715 143.39 37.5053 143.39H46.7109L44.3564 141.019C44.1197 140.781 44.1197 140.396 44.3564 140.157C44.593 139.919 44.9753 139.919 45.212 140.157L48.6102 143.573C48.8469 143.812 48.8469 144.197 48.6102 144.435L45.2181 147.851C44.9814 148.083 44.593 148.083 44.3624 147.851Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10512_2732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.9481 15.8595H43.2965V22.1487H47.4062V24.561H40.9481V15.8595ZM48.7062 15.8595H55.4997V17.9272H51.0126V19.2626H55.0804V21.1579H51.0126V22.5364H55.5417V24.6041H48.7062V15.8595ZM59.9868 15.8164H62.2513L65.8578 24.561H63.3417L62.7126 23.0103H59.4417L58.8546 24.561H56.3804L59.9868 15.8164ZM62.0417 21.1149L61.1191 18.6595L60.1546 21.1149H62.0417ZM66.9901 15.8595H70.261C73.2804 15.8595 75.0417 17.6256 75.0417 20.1672C75.0417 22.6656 73.2804 24.5179 70.2191 24.5179H66.9901V15.8595ZM70.261 22.4072C71.6449 22.4072 72.6094 21.6318 72.6094 20.2103V20.1672C72.6094 18.7887 71.6868 17.9703 70.261 17.9703H69.2965V22.4072H70.261Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0935 36.28L46.3161 35.5477L44.429 29.6031L48.329 28.3108L47.6161 26.0277L41.4935 28.0523L44.0935 36.28ZM29.5419 21.3323L30.2548 19.0492L36.0419 20.9877L37.929 15L40.1516 15.7323L37.5516 24.0031L29.5419 21.3323ZM43.3806 36.6677L41.4935 38.0892L37.8871 33.0062L29.3323 38.52L23 43L29.4581 33.0062L32.6871 27.6646L27.7387 23.96L29.1226 22.0215L36 27.1477L29.8774 35.9354L38.4323 29.6462L43.3806 36.6677Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10512_2732",
    x: 16,
    y: 125,
    width: 54,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10512_2732"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10512_2732",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10512_2732",
    x1: 77.6996,
    y1: 156.114,
    x2: 77.6996,
    y2: 206.219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10512_2732",
    x1: 63.9472,
    y1: 155.176,
    x2: 63.9472,
    y2: 205.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10512_2732",
    x1: 70.6664,
    y1: 166.887,
    x2: 70.6664,
    y2: 214.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10512_2732",
    x1: 83.2219,
    y1: 170.093,
    x2: 83.2219,
    y2: 214.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10512_2732",
    x1: 58.2832,
    y1: 175.448,
    x2: 58.2832,
    y2: 212.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35A3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#339999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#2E8183"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C767A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10512_2732",
    x1: 70.7485,
    y1: 204.784,
    x2: 70.7485,
    y2: 223.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_10512_2732",
    x1: 175.702,
    y1: 171.398,
    x2: 128.563,
    y2: 171.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_10512_2732",
    x1: 150.006,
    y1: 217.158,
    x2: 150.006,
    y2: 201.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_10512_2732",
    x1: 150.006,
    y1: 140.712,
    x2: 150.006,
    y2: 197.755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#499EB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3581A7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_10512_2732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.799 163.543) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_10512_2732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.799 163.544) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_10512_2732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.799 163.545) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_10512_2732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.799 163.544) rotate(180) scale(35.0529 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_10512_2732",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(152.799 163.545) rotate(180) scale(35.053 35.3618)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFE643"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#B6DC41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#9DC43D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97BD3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_10512_2732",
    x1: 173.356,
    y1: 219.18,
    x2: 126.656,
    y2: 219.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_10512_2732",
    x1: 184.029,
    y1: 174.268,
    x2: 125.928,
    y2: 174.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_10512_2732",
    x1: 82.3999,
    y1: 193.539,
    x2: 82.4978,
    y2: 226.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_10512_2732",
    x1: 179.313,
    y1: 219.431,
    x2: 180.969,
    y2: 225.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_10512_2732",
    x1: 180.68,
    y1: 219.247,
    x2: 180.7,
    y2: 225.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_10512_2732",
    x1: 179.317,
    y1: 219.429,
    x2: 180.973,
    y2: 225.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_10512_2732",
    x1: 171.529,
    y1: 151.236,
    x2: 171.746,
    y2: 223.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_10512_2732",
    x1: 144.006,
    y1: 218.149,
    x2: 140.657,
    y2: 229.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_10512_2732",
    x1: 143.072,
    y1: 221.452,
    x2: 140.607,
    y2: 230.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_10512_2732",
    x1: 151.86,
    y1: 151.295,
    x2: 152.077,
    y2: 223.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_10512_2732",
    x1: 162.184,
    y1: 144.965,
    x2: 162.219,
    y2: 156.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_10512_2732",
    x1: 162.201,
    y1: 151.266,
    x2: 162.418,
    y2: 223.739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEEA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EB945B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_10512_2732",
    x1: 162.21,
    y1: 154.107,
    x2: 162.233,
    y2: 161.964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#503D3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_10512_2732",
    x1: 146.219,
    y1: 192.633,
    x2: 146.318,
    y2: 225.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_10512_2732",
    x1: 142.528,
    y1: 192.643,
    x2: 142.627,
    y2: 225.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_10512_2732",
    x1: 164.583,
    y1: 192.578,
    x2: 164.682,
    y2: 225.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#987FC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60578F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_10512_2732",
    x1: 119.607,
    y1: 194.564,
    x2: 119.644,
    y2: 206.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_10512_2732",
    x1: 102.872,
    y1: 194.614,
    x2: 102.909,
    y2: 206.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_10512_2732",
    x1: 119.585,
    y1: 187.267,
    x2: 119.608,
    y2: 194.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_10512_2732",
    x1: 105.935,
    y1: 187.309,
    x2: 105.958,
    y2: 194.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_10512_2732",
    x1: 119.641,
    y1: 206.312,
    x2: 119.7,
    y2: 226.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB5D84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF2F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_10512_2732",
    x1: 151.628,
    y1: 185.225,
    x2: 151.628,
    y2: 226.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_10512_2732",
    x1: 151.628,
    y1: 186.33,
    x2: 151.628,
    y2: 225.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D5C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#56ACB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49A0AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_10512_2732",
    x1: 151.628,
    y1: 185.226,
    x2: 151.628,
    y2: 226.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_10512_2732",
    x1: 151.628,
    y1: 185.225,
    x2: 151.628,
    y2: 226.639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_10512_2732",
    x1: 151.628,
    y1: 185.226,
    x2: 151.628,
    y2: 226.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_10512_2732",
    x1: 151.628,
    y1: 185.225,
    x2: 151.628,
    y2: 226.638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544140"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#493635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#463332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_10512_2732",
    x1: 151.586,
    y1: 194.623,
    x2: 151.586,
    y2: 206.294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_10512_2732",
    x1: 151.635,
    y1: 215.28,
    x2: 151.635,
    y2: 222.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E57830"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_10512_2732",
    x1: 62,
    y1: 155,
    x2: 22.0901,
    y2: 150.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_10512_2732",
    x1: 43,
    y1: 101.604,
    x2: 43,
    y2: 155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEDA44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5F00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10512_2732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 226,
    rx: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10512_2732"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 28,
    fill: "white",
    transform: "translate(23 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpShort);
export default __webpack_public_path__ + "static/media/CP_Short.f415a1de0b09756c3fb92065d24bea14.svg";
export { ForwardRef as ReactComponent };